import {Fab, Tooltip, makeStyles} from '@material-ui/core';
import {green} from '@material-ui/core/colors';
import {ArrowUpward} from '@material-ui/icons';
import React, {useEffect, useState} from 'react';

const useStyles = makeStyles(theme => ({
  scrollToTopButton: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    zIndex: 9999,
    opacity: 0,
    color: 'white',
    backgroundColor: green[300],
    transition: '0.25s all ease-out',
    '&:hover': {
      backgroundColor: green[500],
      opacity: 1,
    },
  },
  enabledScrollToTopButton: {
    display: 'inline-block',
    opacity: 0.7,
  },
}));

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);
  const classes = useStyles();

  const handleScroll = () => {
    const position = window.scrollY;
    setVisible(position >= 200);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, {passive: true});

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleClick = () => {
    window.scrollTo({top: 0, behavior: 'smooth'}); // For Chrome, Firefox, IE and Opera
  };

  return (
    <Tooltip placement="top" title="Scroll to top">
      {/* <span> Needed for tooltip to work correctly */}
      <span>
        <Fab
          className={`${classes.scrollToTopButton} ${visible ? classes.enabledScrollToTopButton : ''}`}
          disabled={!visible}
          onClick={handleClick}
        >
          <ArrowUpward />
        </Fab>
      </span>
    </Tooltip>
  );
};

export default ScrollToTopButton;
